import { uploadDocument, downloadRequestInvoice, downloadRequestDetailInvoice, uploadDoc, viewDoc, verifyDoc } from '@/api/file.api'

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT'
export const UPLOAD_DOCUMENT_LOADING = 'UPLOAD_DOCUMENT_LOADING'
export const UPLOAD_DOCUMENT_DONE = 'UPLOAD_DOCUMENT_DONE'
export const UPLOAD_DOCUMENT_ERROR = 'UPLOAD_DOCUMENT_ERROR'

export const UPLOAD_COMPANY_DOCUMENT = 'UPLOAD_COMPANY_DOCUMENT'
export const UPLOAD_COMPANY_DOCUMENT_LOADING = 'UPLOAD_COMPANY_DOCUMENT_LOADING'
export const UPLOAD_COMPANY_DOCUMENT_DONE = 'UPLOAD_COMPANY_DOCUMENT_DONE'
export const UPLOAD_COMPANY_DOCUMENT_ERROR = 'UPLOAD_COMPANY_DOCUMENT_ERROR'

export const VERIFY_COMPANY_DOCUMENT = 'VERIFY_COMPANY_DOCUMENT'
export const VERIFY_COMPANY_DOCUMENT_LOADING = 'VERIFY_COMPANY_DOCUMENT_LOADING'
export const VERIFY_COMPANY_DOCUMENT_DONE = 'VERIFY_COMPANY_DOCUMENT_DONE'
export const VERIFY_COMPANY_DOCUMENT_ERROR = 'VERIFY_COMPANY_DOCUMENT_ERROR'

export const VIEW_COMPANY_DOCUMENT = 'VIEW_COMPANY_DOCUMENT'
export const VIEW_COMPANY_DOCUMENT_LOADING = 'VIEW_COMPANY_DOCUMENT_LOADING'
export const VIEW_COMPANY_DOCUMENT_DONE = 'VIEW_COMPANY_DOCUMENT_DONE'
export const VIEW_COMPANY_DOCUMENT_ERROR = 'VIEW_COMPANY_DOCUMENT_ERROR'

export const DOWNLOAD_REQUEST_INVOICE = 'DOWNLOAD_REQUEST_INVOICE'
export const DOWNLOAD_REQUEST_INVOICE_LOADING = 'DOWNLOAD_REQUEST_INVOICE_LOADING'
export const DOWNLOAD_REQUEST_INVOICE_DONE = 'DOWNLOAD_REQUEST_INVOICE_DONE'
export const DOWNLOAD_REQUEST_INVOICE_ERROR = 'DOWNLOAD_REQUEST_INVOICE_ERROR'

export const DOWNLOAD_REQUEST_DETAIL_INVOICE = 'DOWNLOAD_REQUEST_DETAIL_INVOICE'
export const DOWNLOAD_REQUEST_DETAIL_INVOICE_LOADING = 'DOWNLOAD_REQUEST_DETAIL_INVOICE_LOADING'
export const DOWNLOAD_REQUEST_DETAIL_INVOICE_DONE = 'DOWNLOAD_REQUEST_DETAIL_INVOICE_DONE'
export const DOWNLOAD_REQUEST_DETAIL_INVOICE_ERROR = 'DOWNLOAD_REQUEST_DETAIL_INVOICE_ERROR'

export default {
  [UPLOAD_DOCUMENT] (context, formData) {
    context.commit(UPLOAD_DOCUMENT_LOADING)
    return uploadDocument(formData)
      .then((response) => {
        context.commit(UPLOAD_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(UPLOAD_DOCUMENT_ERROR, error)
        console.error(error)
      })
  },

  [UPLOAD_COMPANY_DOCUMENT] (context, payload) {
    context.commit(UPLOAD_COMPANY_DOCUMENT_LOADING)
    return uploadDoc(payload)
      .then((response) => {
        context.commit(UPLOAD_COMPANY_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(UPLOAD_COMPANY_DOCUMENT_ERROR, error)
        console.error(error)
      })
  },

  [DOWNLOAD_REQUEST_INVOICE] (context, {bidId, type, fileName}) {
    context.commit(DOWNLOAD_REQUEST_INVOICE_LOADING)
    return downloadRequestInvoice({bidId, type, fileName})
      .then((response) => {
        context.commit(DOWNLOAD_REQUEST_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_REQUEST_INVOICE_ERROR, true)
        console.error(error)
      })
  },
  [DOWNLOAD_REQUEST_DETAIL_INVOICE] (context, {bidId, type, fileName}) {
    context.commit(DOWNLOAD_REQUEST_DETAIL_INVOICE_LOADING)
    return downloadRequestDetailInvoice({bidId, type, fileName})
      .then((response) => {
        context.commit(DOWNLOAD_REQUEST_DETAIL_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_REQUEST_DETAIL_INVOICE_ERROR, true)
        console.error(error)
      })
  },

  [VIEW_COMPANY_DOCUMENT] (context, payload) {
    context.commit(VIEW_COMPANY_DOCUMENT_LOADING)
    return viewDoc(payload)
      .then((response) => {
        context.commit(VIEW_COMPANY_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(VIEW_COMPANY_DOCUMENT_ERROR, error)
        console.error(error)
      })
  },

  [VERIFY_COMPANY_DOCUMENT] (context, payload) {
    context.commit(VERIFY_COMPANY_DOCUMENT_LOADING)
    return verifyDoc(payload)
      .then((response) => {
        context.commit(VERIFY_COMPANY_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(VERIFY_COMPANY_DOCUMENT_ERROR, error)
        console.error(error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/file/actions.js